module.exports = __webpack_public_path__ + "img/button_settings.fa0df106.svg";